import { Save } from '@mui/icons-material';
import { Box, Button, Dialog, Input, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { SupportServices } from '../../services/api/suport/SuportServices';

interface SupportProps {
	open: boolean;
	close: () => void;
	create: () => void;
	error: () => void;
	invalid: () => void;
}

export default function SupportDialog({ close, open, create, error, invalid }: SupportProps) {

	const [loadin, setLodin] = useState<boolean>(false);
	const [data, setData] = useState<any>({
		mensagem: '',
		file: undefined,
	});

	const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files && e.target.files.length > 0) {
			const file = e.target.files[0];
			setData({ ...data, file: file });
		}
	};

	async function onCreate() {
		setLodin(true);
		if (data.mensagem !== '') {
			SupportServices.create(data).then((response) => {
				if (response instanceof Error) {
					console.log('Error', response);
					error();
					setLodin(false);
				} else {
					close();
					setLodin(false);
					create();
				}
			});
		} else {
			setLodin(false);
			invalid();
		}
	}

	return (
		<Dialog
			open={open}
			onClose={close}
			sx={{ borderRadius: '25px' }}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column', padding: 2, gap: 2 }}>
				<Typography>A mensagem enviada ao suporte será analisada, e uma resposta será enviada ao e-mail referente ao seu cadastro.</Typography>
				<TextField
					label='Mensagem para o suporte'
					multiline
					fullWidth
					maxRows={100}
					rows={5}
					required
					onChange={(e) => setData({ ...data, mensagem: e.target.value })}
				/>
				<TextField
					type='file'
					fullWidth
					onChange={onFileChange}
					sx={{
						'& ::file-selector-button': {
							backgroundColor: (theme) => theme.palette.primary.main,
							color: (theme) => theme.palette.getContrastText(theme.palette.primary.main), // Garante o contraste do texto
							borderRadius: '25px',
							border: 'none',
							padding: '5px',
							cursor: 'pointer',
							transition: 'background-color 0.2s',
						},
					}}
				/>
				<Button startIcon={<Save />} variant='contained' onClick={onCreate} disabled={loadin}>Salvar</Button>
			</Box>
		</Dialog>
	);
}